/**
 * Check objects for equivalency. Will not work for nested objects.
 * @param {object}  first   The first object to check for equivalency.
 * @param {object}  second  The second object to check for equilvalency.
 * @returns {boolean}
 */
export default function isEquivalent(first, second) {
  // Create arrays of property names
  const firstProps = Object.getOwnPropertyNames(first);
  const secondProps = Object.getOwnPropertyNames(second);

  // If number of properties is different,
  // objects are not equivalent
  if (firstProps.length !== secondProps.length) {
    return false;
  }

  for (let i = 0; i < firstProps.length; i += 1) {
    const propName = firstProps[i];

    // If values of same property are not equal,
    // objects are not equivalent
    if (first[propName] !== second[propName]) {
      return false;
    }
  }

  // If we made it this far, objects
  // are considered equivalent
  return true;
}



// WEBPACK FOOTER //
// ./app/utils/object/isEquivalent.js